import React from 'react';
import { WitnessSignatureAreaProps, FileTypes } from '@usacsmideo/types';
import { DocuSignSigBox } from './DocuSignSigBox';
import { SignatureBox } from './SignatureBox';
import { useUpdateChartSection } from '../hooks/useUpdateChartSection';
import { Button } from '../components/buttons/Button';
// import { DesignPencil, MailOut } from 'iconoir-react';
import * as Sentry from '@sentry/browser';

export const WitnessSignatureArea = (props: WitnessSignatureAreaProps) => {
  const { mutate } = useUpdateChartSection();

  // const [isDocuSign, setIsDocuSign] = React.useState(true);
  const isDocuSign = true;

  React.useEffect(() => {
    if (props.setWitnessOneIsDocuSign && props.data.WITNESS_SIGNATURE.signature1Docusign?.status === 'sent') {
      props.setWitnessOneIsDocuSign(true);
    }
    if (props.setWitnessTwoIsDocuSign && props.data.WITNESS_SIGNATURE.signature2Docusign?.status === 'sent') {
      props.setWitnessTwoIsDocuSign(true);
    }
  }, [props]);

  // const handleToggle = () => {
  //   if (props.setWitnessOneIsDocuSign) {
  //     props.setWitnessOneIsDocuSign(!isDocuSign);
  //   }
  //   if (props.setWitnessTwoIsDocuSign) props.setWitnessTwoIsDocuSign(!isDocuSign);
  //   setIsDocuSign(!isDocuSign);
  // };
  const handleRemoveWitness = () => {
    mutate(
      {
        patientId: props.patientId,
        docData: {
          WITNESS_SIGNATURE: {
            signature1DataURI:
              props.data.WITNESS_SIGNATURE.signature1DataURI && props.witnessNumber === 1
                ? ''
                : props.data.WITNESS_SIGNATURE.signature1DataURI,
            witnessName: props.data.WITNESS_SIGNATURE.witnessName || '',
            witnessEmail: props.data.WITNESS_SIGNATURE.witnessEmail || '',
            signature2DataURI:
              props.data.WITNESS_SIGNATURE.signature2DataURI && props.witnessNumber === 2
                ? ''
                : props.data.WITNESS_SIGNATURE.signature2DataURI,
            witness2Name: props.data.WITNESS_SIGNATURE.witness2Name || '',
            witness2Email: props.data.WITNESS_SIGNATURE.witness2Email || '',
          },
        },
      },
      {
        onSuccess: () => {
          // alert("Successfully updated document");
        },
        onError: (error) => {
          Sentry.captureException(error);
          alert(`Error updating document: ${error.message}`); // TELL THE USER
          console.error(error); // GET THE STACKTRACE
        },
      },
    );
  };

  const cancelDocusignRequest = () => {
    mutate(
      {
        patientId: props.patientId,
        docData: {
          WITNESS_SIGNATURE: {
            signature1DataURI: props.witnessNumber === 1 ? '' : props.data.WITNESS_SIGNATURE.signature1DataURI,
            witnessName: props.witnessNumber === 1 ? '' : props.data.WITNESS_SIGNATURE.witnessName,
            witnessEmail: props.witnessNumber === 1 ? '' : props.data.WITNESS_SIGNATURE.witnessEmail,
            signature2DataURI: props.witnessNumber === 2 ? '' : props.data.WITNESS_SIGNATURE.signature2DataURI,
            witness2Name: props.witnessNumber === 2 ? '' : props.data.WITNESS_SIGNATURE.witness2Name,
            witness2Email: props.witnessNumber === 2 ? '' : props.data.WITNESS_SIGNATURE.witness2Email,
          },
        },
      },
      {
        onSuccess: () => {
          // alert("Successfully updated document");
        },
        onError: (error) => {
          Sentry.captureException(error);
          alert(`Error updating document: ${error.message}`); // TELL THE USER
          console.error(error); // GET THE STACKTRACE
        },
      },
    );
  };

  return (
    <div>
      {/* <div className="flex flex-row items-center">
        <p className="font-color-sky-700 mr-2 text-xl">Capture Signature Here</p>
        <DesignPencil />
        <label className="mx-2 inline-flex cursor-pointer items-center">
          <input
            type="checkbox"
            checked={
              props.witnessNumber === 1
                ? props.data.WITNESS_SIGNATURE?.witnessEmail?.length > 0 || isDocuSign
                : props.data.WITNESS_SIGNATURE?.witness2Email?.length > 0 || isDocuSign
            }
            className="peer sr-only"
            onClick={() => handleToggle()}
            disabled={
              props.witnessNumber === 1
                ? props.data.WITNESS_SIGNATURE?.signature1DataURI?.length > 0
                : props.data.WITNESS_SIGNATURE?.signature2DataURI?.length > 0
            }
          />
          <div className="peer relative h-6 w-11 rounded-full bg-gray-200 peer-checked:bg-blue-600 peer-focus:ring-4 peer-focus:ring-blue-300 after:absolute after:start-[2px] after:top-0.5 after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:after:translate-x-full peer-checked:after:border-white peer-checked:rtl:after:-translate-x-full dark:border-gray-600 dark:bg-gray-700 dark:peer-focus:ring-blue-800"></div>
          {}
        </label>
        <MailOut />
        <p className="font-color-sky-700 ml-2 text-xl">Request signature via email</p>
      </div> */}

      {props.witnessNumber === 1 ? (
        props.data.WITNESS_SIGNATURE?.signature1DataURI?.length > 0 ? (
          // IF SIGNATURE ON FILE, DISPLAY SIGNATURE AND REMOVE BUTTON
          <div className="flex flex-row items-center">
            <p>Signature on file:</p>
            <img src={props.data.WITNESS_SIGNATURE.signature1DataURI} alt="Witness One Signature" className="w-1/2" />
            <Button
              id={`remove-sig-${props.witnessNumber}`}
              type="button"
              textContent={`Remove`}
              onClick={handleRemoveWitness}
            />
          </div>
        ) : // IF REQUESTING DOCUSIGN, DISPLAY DOCUSIGN SIGNATURE BOX
        isDocuSign || props.data.WITNESS_SIGNATURE.witnessEmail?.length > 0 ? (
          props.data.WITNESS_SIGNATURE.witnessEmail?.length > 0 ? (
            <div className="flex flex-col">
              <div>{`Awaiting signature from ${props.data.WITNESS_SIGNATURE.witnessEmail}`}</div>
              <div className="w-1/3">
                <Button
                  id="cancel-docusign-1"
                  textContent="Cancel Request"
                  type="button"
                  onClick={cancelDocusignRequest}
                />
              </div>
            </div>
          ) : (
            <DocuSignSigBox
              witnessName={props.witnessName}
              witnessNumber={1}
              patientId={props.patientId}
              patientEmail={props.patientInfo.accountEmail}
              patientName={props.data.PATIENT_INFO_1.firstName + ' ' + props.data.PATIENT_INFO_1.lastName}
              script={props.data.SCRIPT_REVIEW.telePrompterScript}
              data={props.data}
            />
          )
        ) : (
          <div>
            {props.isSigning.witness1 === false ? (
              <Button
                id="signWitness1"
                textContent="Sign Now"
                type="button"
                onClick={() => props.setIsSigning({ ...props.isSigning, witness1: true })}
              />
            ) : (
              <SignatureBox
                elementId={props.elementId}
                type={FileTypes.witness1}
                bucket={'patient'}
                path={`/user/${props.patientId}/signatures/WITNESS_SIGNATURE_WitnessFinalSignature`}
                docToUpdate={'WITNESS_SIGNATURE'}
                patientId={props.patientId}
                hideSigBox={() => props.setIsSigning({ ...props.isSigning, witness1: false })}
              />
            )}
          </div>
        )
      ) : props.data.WITNESS_SIGNATURE.signature2DataURI?.length > 0 ? (
        // IF SIGNATURE ON FILE, DISPLAY SIGNATURE AND REMOVE BUTTON
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <p>Signature on file:</p>
          <img
            src={props.data.WITNESS_SIGNATURE?.signature2DataURI}
            alt="Witness Two Signature"
            style={{ width: '50%' }}
          />
          <Button
            id={`remove-sig-${props.witnessNumber}`}
            type="button"
            textContent={`Remove`}
            onClick={handleRemoveWitness}
          />
        </div>
      ) : // IF REQUESTING DOCUSIGN, DISPLAY DOCUSIGN SIGNATURE BOX
      isDocuSign || props.data.WITNESS_SIGNATURE.witness2Email?.length > 0 ? (
        props.data.WITNESS_SIGNATURE.witness2Email?.length > 0 ? (
          <div className="flex flex-col">
            <div>{`Awaiting signature from ${props.data.WITNESS_SIGNATURE.witness2Email}`}</div>
            <div className="w-1/3">
              <Button
                id="cancel-docusign-2"
                textContent="Cancel Request"
                type="button"
                onClick={cancelDocusignRequest}
              />
            </div>
          </div>
        ) : (
          <DocuSignSigBox
            witnessName={props.witnessName}
            witnessNumber={2}
            patientId={props.patientId}
            patientEmail={props.patientInfo.accountEmail}
            patientName={props.data.PATIENT_INFO_1.firstName + ' ' + props.data.PATIENT_INFO_1.lastName}
            script={props.data.SCRIPT_REVIEW.telePrompterScript}
            data={props.data}
          />
        )
      ) : (
        <div>
          {props.isSigning.witness2 === false ? (
            <Button
              id="signWitness2"
              textContent="Sign Now"
              type="button"
              onClick={() => props.setIsSigning({ ...props.isSigning, witness2: true })}
            />
          ) : (
            <SignatureBox
              elementId={props.elementId}
              type={FileTypes.witness2}
              bucket={'patient'}
              path={`/user/${props.patientId}/signatures/WITNESS_SIGNATURE_Witness2FinalSignature`}
              docToUpdate={'WITNESS_SIGNATURE'}
              patientId={props.patientId}
              hideSigBox={() => props.setIsSigning({ ...props.isSigning, witness2: false })}
            />
          )}
        </div>
      )}
    </div>
  );
};
